import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { TListProps, TListSize } from '@r1-frontend/ui-react/experimental/containers/ListContainer';

type TFlexibleListContainerProps = TListProps & {
    $tablet?: TListSize,
}

const getGapBySizeProps = ({ $tablet }: TFlexibleListContainerProps) => {
    if (typeof $tablet !== 'undefined') {
        return css`
            @media (max-width: ${wideBreakpoints.tablet}) {
                gap: ${() => `${$tablet}px`};
            }
        `;
    } else {
        return '';
    }
};

const FlexibleListContainer = styled(ListContainer)<TFlexibleListContainerProps>`
    ${getGapBySizeProps}
`;

export default FlexibleListContainer;
